<script setup lang="ts">
import { addDays, isToday } from 'date-fns';
import { computed } from 'vue';
import { formatDate } from '@/utils/format-date';

interface Props {
  productBooking: ProductBooking
}

const props = defineProps<Props>();

const returnDate = computed(() => addDays(new Date(props.productBooking.endDate), 1));
const returnToday = computed(() => isToday(returnDate.value));

</script>
<template>
  <div class="flex flex-col">
    <base-tip
      v-if="returnToday"
      title="Hoy es la devolución"
      variant="bold"
    >
      Coordina la devolución del producto con el cliente a través del
      <a
        :href="`/chats/${productBooking.chatId}`"
        class="font-medium underline underline-offset-2"
      >
        chat
      </a>.
    </base-tip>
    <base-tip
      v-else
      title="Devolución"
      variant="bold"
    >
      Recuerda que la devolución será el {{ formatDate(returnDate.toDateString()) }} antes del mediodía.
    </base-tip>
  </div>
</template>
